import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["userSelect"]

  selectAll() {
    const tomSelectInstance = this.userSelectTarget.tomselect
    if (tomSelectInstance) {
      // Get all available options and add them as items
      Object.keys(tomSelectInstance.options).forEach(value => {
        tomSelectInstance.addItem(value, true) // silent = true to prevent multiple change events
      })
    }
  }

  deselectAll() {
    const tomSelectInstance = this.userSelectTarget.tomselect
    if (tomSelectInstance) {
      tomSelectInstance.clear(true) // silent = true to prevent change event
    }
  }
}